// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2ha9h","header":"PatientQuestionnaire_header__15MTJ","info":"PatientQuestionnaire_info__5TS_r"};